import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// Consume a navigation request once; the existing component still owns its form.
export function useJobAction(name, onOpen, enabled = true) {
  const location = useLocation();
  const navigate = useNavigate();
  const handled = useRef(null);
  const callback = useRef(onOpen);
  callback.current = onOpen;
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (!enabled || params.get("action") !== name || handled.current === location.key) return;
    handled.current = location.key;
    params.delete("action");
    navigate({ pathname: location.pathname, search: params.toString(), hash: location.hash }, { replace: true });
    callback.current();
  }, [enabled, name, location.key, location.pathname, location.search, location.hash, navigate]);
}
